import FAQs, {
  GuideFAQ, 
  PorterGuideFAQ,
 } from './FAQs';

export default FAQs;

export {
  GuideFAQ,
  PorterGuideFAQ,
}
